import React, { useState } from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';

const useStyles = makeStyles(theme => ({
    wrapper: {
        position: 'fixed',
        top: '20rem',
        right: '2rem',
        marginTop: theme.spacing(1),
        height: 380,
    },
    speedDial: {
        position: 'absolute',
        '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
            bottom: theme.spacing(2),
            right: theme.spacing(2),
        },
        '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
            top: theme.spacing(2),
            left: theme.spacing(2),
        },
    },
}));

/**
 * Boton de accion flotante capaz de mostrar hasta 6 botones desplegables relacionados.
 */
const SpeedDialDS = (props) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <SpeedDial
            ariaLabel="Speed Dial DS"
            className={classes.speedDial}
            hidden={props.hidden}
            icon={<SpeedDialIcon icon={props.icon} openIcon={props.openIcon} />}
            onClose={handleClose}
            onOpen={handleOpen}
            open={open}
            direction={props.direction}
        >
            {
                props.actions.map(action => {
                    return (
                        <SpeedDialAction
                            key={action.name}
                            tooltipTitle={action.name}
                            {...action}

                        />
                    )
                })
            }
        </SpeedDial>
    );
}

SpeedDialDS.propTypes = {
    /**
     * Si es true el SpeedDial no es visible.
     */
    hidden: PropTypes.bool,
    /**
     * Objeto a mostrar como icono del SpeedDial.
     */
    icon: PropTypes.node,
    /**
     * Objeto a mostrar como icon del SpeedDial cuando las acciones estan desplegadas.
     */
    openIcon: PropTypes.node,
    /**
     * Direccion hacia la cual se desplegaran las acciones.
     */
    direction: PropTypes.oneOf(['up', 'right', 'down', 'left']),
    /**
     * Arreglo de objetos con la informacion de cada accion del speed dial. Son obligatorios
     * el icono de la accion, el nombre que servira tambien como identificador y la accion a realizar al hacer click.
     * Otras propiedades que puede aceptar son las propiedades de SpeedDialAction de Material-UI: https://material-ui.com/api/speed-dial-action/
     */
    actions: PropTypes.arrayOf(PropTypes.shape(
        {
            icon: PropTypes.node.isRequired,
            name: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
        }
    )),
}

SpeedDialDS.defaultProps = {
    hidden: false,
    direction: 'up',
    actions: [
        {
            name: 'Muestra',
            icon: <ContactSupportIcon />,
            onClick: () => {
                window.alert('Soy la accion default!');
            }
        }
    ]
}

export default SpeedDialDS;